// src/context/ShipstyleContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_URL } from '../config/config';

const ShipstyleContext = createContext();

export const ShipstyleProvider = ({ children }) => {
  const [shipstyles, setShipstyles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchShipstyles = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}/ship-styles`);
      const json = await res.json();

      if (res.ok && json.status === 200) {
        setShipstyles(json.data);
      } else {
        throw new Error(json.message || 'Failed to fetch ship styles');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShipstyles();
  }, []);

  return (
    <ShipstyleContext.Provider value={{ shipstyles, loading, error }}>
      {children}
    </ShipstyleContext.Provider>
  );
};

export const useShipstyles = () => useContext(ShipstyleContext);
